<template>
  <v-dialog :value="active" persistent max-width="450">
    <v-card>
      <v-toolbar card color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title >{{title}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text
        style="text-align: center"
      >{{message}}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          color="primary darken-1"
          flat="flat"
          @click.native="$emit('confirmation')"
        >Valider</v-btn>
        <v-btn
          :disabled="loading"
          color="secondary darken-1"
          flat="flat"
          @click.native="$emit('cancel')"
        >Annuler</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    active: Boolean,
    loading: Boolean,
    title: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  methods: {},
  computed: {}
};
</script>

